import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { Link } from "react-router-dom";

import { Text, Grid, Card, BlockStack, DescriptionList, Button, Divider, Banner, Link as PolarisLink } from '@shopify/polaris';
import useShopifyCurrencyFormat from '../hooks/currencyFormat';

import {
         PlusIcon,
         ClipboardChecklistIcon,
         ExternalIcon
       } from '@shopify/polaris-icons';

import LoadingSpinner from '../partials/LoadingSpinner';

const SubmittedMessage = ({ moneyFormat, orderSession, resetSession }) => {
  const [submitted, setSubmitted] = useState(false);
  const [error, setError] = useState(null);
  const [fulfillmentStatus, setFulfillmentStatus] = useState('');
  const [paymentStatus, setPaymentStatus] = useState('');

  const formatPriceValue = (value) => {
    const currencyFormat = useShopifyCurrencyFormat(moneyFormat);
    return currencyFormat(value);
  }

  if(orderSession.status === 'success' && moneyFormat) {
    return (
      <Grid>
        <Grid.Cell columnSpan={{xs: 6, sm: 3, md: 3, lg: 6, xl: 6}}>
          <Card>
            <BlockStack gap="200">
              <Text variant="headingSm" as="h6">Order Actions</Text>
              <DescriptionList
                items={[
                  {
                    term: 'View Order',
                    description:
                      <>
                        { orderSession.completeOrderId &&
                          <PolarisLink target="_blank" url={`https://admin.shopify.com/orders/${orderSession.orderId}`}>
                            <Button icon={ExternalIcon}>View Order</Button>
                          </PolarisLink>
                        }
                        { !orderSession.completeOrderId &&
                          <PolarisLink target="_blank" url={`https://admin.shopify.com/draft_orders/${orderSession.orderId}`}>
                            <Button icon={ExternalIcon}>View Order</Button>
                          </PolarisLink>
                        }
                      </>
                  },
                  {
                    term: 'Pick and Verify',
                    description:
                      <>
                        { orderSession.completeOrderId &&
                          <Link to={`/pick/${orderSession.completeOrderId}${window.location.search}`}>
                            <Button icon={ClipboardChecklistIcon} variant="primary">Pick and Verify Order</Button>
                          </Link>
                        }
                        { !orderSession.completeOrderId &&
                          <Text>Complete order to pick and verify.</Text>
                        }
                      </>
                  }
                ]}
              />
            </BlockStack>
          </Card>
        </Grid.Cell>
        <Grid.Cell columnSpan={{xs: 6, sm: 3, md: 3, lg: 6, xl: 6}}>
          <Card>
            <BlockStack gap="200">
              <Text variant="headingSm" as="h6">Order Details</Text>
              <DescriptionList
                items={[
                  {
                    term: 'Subtotal',
                    description:
                      <Text>
                        {formatPriceValue(orderSession.order.subtotalPriceSet.shopMoney.amount)}
                      </Text>
                  },
                  {
                    term: 'Tax',
                    description:
                      <Text>
                        {formatPriceValue(orderSession.order.totalTaxSet.shopMoney.amount)}
                      </Text>
                  },
                  {
                    term: 'Grand Total',
                    description:
                      <Text>
                        {formatPriceValue(orderSession.order.totalPriceSet.shopMoney.amount)}
                      </Text>
                  }
                ]}
              />
              <Divider />
          
              <Button icon={PlusIcon} variant="primary" onClick={() => resetSession()}>New Order</Button>
            </BlockStack>
          </Card>
        </Grid.Cell>
      </Grid>
    )
  }

  if(orderSession.status === 'requesting') {
    return (
      <>
        <LoadingSpinner size="small"/>
      </>
    )
  }

  if(orderSession.status === 'error') {
    return(
      <Banner 
        title="Order Creation Failed"
        tone="critical"
      >
        <p>
          Order creation failed with the following message: { orderSession.error }
        </p>
      </Banner>
    )
  }
}

const mapStateToProps = state => ({
  orderSession: state.orderSessions,
  moneyFormat: state?.shops?.shopSettings?.shop?.currencyFormats?.moneyFormat,
});

const mapDispatchToProps = (dispatch) => ({

});

export default connect(mapStateToProps, mapDispatchToProps)(SubmittedMessage);
